import TweenLite from 'gsap/TweenLite'

// Store cleanup functions
let cleanupFunctions = []
let initTimeout = null

export function calcNavHeight({ $body, $navbar, $announcementBar }) {
  const navfixed = $body.hasClass('navbar-is-fixed')
  const nh = $navbar.outerHeight()
  const ah = $announcementBar.outerHeight()
  let calcHeight = nh
  if ($announcementBar.length > 0 && !navfixed) {
    calcHeight = nh + ah
  }
  return calcHeight
}

function initNavbarScroll() {
  const $body = $('body')
  const $navbar = $('#mainNav')
  const $announcementBar = $('[data-banner-location=top]')

  // Exit early if navbar doesn't exist
  if (!$navbar.length) {
    console.warn('Navbar element #mainNav not found, skipping navbar scroll initialization')
    return
  }
  let topOffset = $navbar.outerHeight()
  let navResizeTime
  /* eslint-disable-next-line no-unused-vars */
  let scrollPos
  let scrollTime

  let scrollToClear = calcNavHeight({ $body, $navbar, $announcementBar }) * 2

  // Navbar
  const resizeHandler = () => {
    clearTimeout(navResizeTime)
    navResizeTime = setTimeout(() => {
      scrollToClear = calcNavHeight({ $body, $navbar, $announcementBar }) * 2
      topOffset = $navbar.outerHeight()
    }, 100)
  }

  const scrollHandler = () => {
    clearTimeout(scrollTime)
    /* eslint-disable-next-line */
    const currentScroll = $(window).scrollTop();

    if ($(window).scrollTop() > scrollToClear) {
      $navbar.addClass('navbar-fixed-top')
      if ($navbar.hasClass('-transparent')) {
        $navbar
          .addClass('-default -was-transparent')
          .removeClass('-transparent')
      }
      const mainNavElement = document.getElementById('mainNav')
      if (mainNavElement) {
        TweenLite.to(mainNavElement, 0.5, {
          y: topOffset - 5
        })
      }
      $body.addClass('navbar-is-fixed')
    }

    if ($(window).scrollTop() < scrollToClear) {
      $navbar.removeClass('navbar-fixed-top')
      if ($navbar.hasClass('-was-transparent')) {
        $navbar
          .removeClass('-default -was-transparent')
          .addClass('-transparent')
      }
      const mainNavElement = document.getElementById('mainNav')
      if (mainNavElement) {
        TweenLite.to(mainNavElement, 0.5, {
          y: 0
        })
      }
      $body.removeClass('navbar-is-fixed')
    }
    scrollTime = setTimeout(() => {
      scrollPos = $(window).scrollTop()
    }, 100)
  }

  // Attach event handlers
  $(window).on('resize', resizeHandler)
  $(window).on('scroll', scrollHandler)

  // Store cleanup function
  cleanupFunctions.push(() => {
    $(window).off('resize', resizeHandler)
    $(window).off('scroll', scrollHandler)
    clearTimeout(navResizeTime)
    clearTimeout(scrollTime)
  })
}
// Export cleanup function for React components to use
export function navbarScrollCleanup() {
  // Clear init timeout if it exists
  if (initTimeout) {
    clearTimeout(initTimeout)
    initTimeout = null
  }

  // Run all cleanup functions
  cleanupFunctions.forEach(cleanup => cleanup())
  cleanupFunctions = []
}

export default function navbarScroll() {
  // Clean up any existing handlers first
  navbarScrollCleanup()

  $(document).ready(() => {
    initTimeout = setTimeout(() => {
      initNavbarScroll()
    }, 3000)
  })
}
